import { render } from "./TrustSignals.vue?vue&type=template&id=03ba800b&scoped=true"
import script from "./TrustSignals.vue?vue&type=script&lang=js"
export * from "./TrustSignals.vue?vue&type=script&lang=js"

import "./TrustSignals.vue?vue&type=style&index=0&id=03ba800b&scoped=true&lang=css"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03ba800b"]])

export default __exports__